/**
 * All Lucide Icons used in Querybook
 *
 * Please make sure the list is Alphabetically sorted
 * When adding, add to both import and export
 *
 */
import {
    Activity,
    AlertCircle,
    AlertOctagon,
    AlertTriangle,
    AlignCenterHorizontal,
    AlignCenterVertical,
    AlignLeft,
    ArrowDown,
    ArrowLeft,
    ArrowRight,
    ArrowUp,
    Bold,
    Book,
    BookOpen,
    Box,
    Briefcase,
    Bug,
    Calendar,
    Check,
    CheckCircle,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronsDown,
    ChevronsUp,
    ChevronUp,
    Circle,
    Clipboard,
    Clock,
    Code,
    Command,
    Copy,
    Crown,
    Database,
    Delete,
    Download,
    Edit,
    Edit2,
    Edit3,
    Expand,
    ExternalLink,
    Eye,
    EyeOff,
    File,
    FileOutput,
    FileText,
    Filter,
    FormInput,
    Github,
    GitPullRequest,
    GripVertical,
    Hash,
    HelpCircle,
    History,
    Home,
    Info,
    Italic,
    Key,
    Languages,
    Layout,
    LayoutGrid,
    Link,
    List,
    ListOrdered,
    Lock,
    LogOut,
    Maximize,
    Maximize2,
    Menu,
    MessageCircle,
    MessageSquare,
    Minimize2,
    Minus,
    MoreVertical,
    MoveVertical,
    Network,
    Pen,
    PenLine,
    Pencil,
    PieChart,
    Play,
    PlayCircle,
    PlugZap,
    Plus,
    Quote,
    RefreshCw,
    Repeat,
    RotateCcw,
    Save,
    Scissors,
    Search,
    Send,
    Server,
    Settings,
    Share,
    Sheet,
    Sidebar,
    Slash,
    Sliders,
    Smile,
    Star,
    Stars,
    Strikethrough,
    Terminal,
    ThumbsDown,
    ThumbsUp,
    Trash,
    Trash2,
    Type,
    Underline,
    Unlink,
    Unlock,
    Upload,
    UserMinus,
    UserPlus,
    Users,
    Volume2,
    Watch,
    X,
    XCircle,
    XOctagon,
    Zap,
} from 'lucide-react';

const AllLucideIcons = {
    Activity,
    AlertCircle,
    AlertOctagon,
    AlertTriangle,
    AlignCenterVertical,
    AlignCenterHorizontal,
    AlignLeft,
    ArrowDown,
    ArrowLeft,
    ArrowRight,
    ArrowUp,
    Bold,
    Book,
    BookOpen,
    Box,
    Briefcase,
    Bug,
    Calendar,
    Check,
    CheckCircle,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    ChevronsDown,
    ChevronsUp,
    Circle,
    Clipboard,
    Clock,
    Code,
    Copy,
    Command,
    Crown,
    Database,
    Delete,
    Download,
    Edit,
    Edit2,
    Edit3,
    Eye,
    EyeOff,
    Expand,
    ExternalLink,
    File,
    FileOutput,
    FileText,
    Filter,
    FormInput,
    Github,
    GitPullRequest,
    GripVertical,
    Hash,
    HelpCircle,
    Home,
    History,
    Info,
    Italic,
    Key,
    Languages,
    Layout,
    LayoutGrid,
    Link,
    List,
    ListOrdered,
    Loading: Circle, // Custom loading icon
    Lock,
    LogOut,
    Maximize,
    Maximize2,
    Menu,
    MessageSquare,
    MessageCircle,
    Minimize2,
    Minus,
    MoreVertical,
    Network,
    MoveVertical,
    Pen,
    PenLine,
    Pencil,
    PieChart,
    Play,
    PlayCircle,
    PlugZap,
    Plus,
    Quote,
    RefreshCw,
    Repeat,
    RotateCcw,
    Save,
    Scissors,
    Search,
    Send,
    Server,
    Settings,
    Sidebar,
    Share,
    Sheet,
    Slash,
    Sliders,
    Smile,
    Star,
    Stars,
    Strikethrough,
    Terminal,
    ThumbsDown,
    ThumbsUp,
    Trash,
    Trash2,
    Type,
    Underline,
    Unlink,
    Unlock,
    Upload,
    UserMinus,
    UserPlus,
    Users,
    Volume2,
    Watch,
    X,
    XCircle,
    XOctagon,
    Zap,
};

export type AllLucideIconNames = keyof typeof AllLucideIcons;
export default AllLucideIcons;
